<template>
  <DashboardLayout>
    <template #top-left>
      <WindChartCard v-bind="config.topLeft"/>
    </template>
    <template #top-right>
      <WindChartCard v-bind="config.topRight"/>
    </template>
    <template #bottom-right>
      <GrafanaChartCard v-bind="config.bottomRight"/>
    </template>
  </DashboardLayout>
</template>

<script>
import DashboardLayout from '@/components/dashboard/DashboardLayout.vue'
import WindChartCard from '@/components/dashboard/WindChartCard.vue'
import GrafanaChartCard from '../components/dashboard/GrafanaChartCard.vue'
import { DASHBOARD_CONFIGS } from '@/components/dashboard/dashboardConfig.js'

export default {
  name: 'DashboardPage3',
  components: {
    DashboardLayout,
    WindChartCard,
    GrafanaChartCard
  },
  computed: {
    config() {
      return DASHBOARD_CONFIGS.page3
    }
  }
}
</script>
